import { NextSeo } from 'next-seo';
import React from 'react';
import CallToActions from '@apps/components/ico-landing/CallToActions';
import FeaturesCard from '@apps/components/crypto/features-card';
import Features from '@apps/components/cryto-trading/Features';
import CardDrawer from '@apps/components/card-drawer/card-drawer';
import Hero_10 from '@apps/components/hero/hero_10';
import Services from '@apps/components/services/services';
import Parks from '@apps/components/careers/parks';

const BlockchainConsulting = () => {
  const metaTitle = "Blockchain Consulting - Alchemis";
  const metaDesc = `Experience the power of blockchain consulting as we guide your business towards decentralized success.`;
  const metaImg = `/images/meta/services-block-consultation.png`;
  const content = {
    title: "Guiding Businesses Towards Decentralized Success",
    descriptions: `Experience the power of blockchain consulting as we guide your business towards decentralized success.`,
    headImage: '/images/alchemis-lab/blockchain-consultation.png',
    animationImage: '/images/alchemis-lab/blockchain-consultation-side.png',
    backgroundImage: '/images/alchemis-lab/background.png',
  };
  const features_data = {
    data: [
      {
        id: 1,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='21' viewBox='0 0 16 21' fill='none'>
              <g clipPath='url(#clip0_384_45245)'>
                <path
                  d='M7.99416 0.5C3.69679 0.5 0.198839 3.79826 0.198839 7.8503H1.98434C1.98434 4.72805 4.67881 2.18739 7.99416 2.18739C11.3095 2.18739 13.9999 4.72805 13.9999 7.8503C13.9999 9.88971 12.8353 12.8972 12.0075 14.3856C11.2567 15.7324 10.3843 16.7962 9.4185 17.5461C8.33097 18.3879 7.1217 18.8164 5.82315 18.8164C3.59494 18.8141 1.78955 17.1103 1.78955 15.0093H0C0 18.0397 2.61332 20.5 5.82315 20.5C9.03299 20.5 11.6463 18.6557 13.5901 15.1662C15.2051 12.2735 15.7895 9.2048 15.7895 7.8503C15.7895 3.79826 12.2915 0.5 7.99416 0.5Z'
                  fill='#8358FF' />
                <path
                  d='M8.45737 14.0031C7.93795 14.4087 7.39013 14.6038 6.77738 14.6038V16.2874C7.80404 16.2874 8.74954 15.9583 9.5936 15.3079C10.255 14.7913 10.8434 14.0835 11.3345 13.1996C12.146 11.7456 12.5681 10.0238 12.5681 9.07103C12.5681 6.66812 10.4945 4.71289 7.95013 4.71289C5.39849 4.71519 3.33056 6.66506 3.32812 9.07103V9.91281H4.22087C4.55038 9.91281 4.81739 10.1642 4.8178 10.4749C4.8178 10.7856 4.55119 11.0374 4.22168 11.0377H4.22087V12.7213C5.53646 12.7248 6.60613 11.7223 6.60979 10.4818C6.61263 9.59332 6.05953 8.78674 5.19884 8.42439C5.57055 6.99144 7.10364 6.11446 8.62334 6.46495C9.89551 6.75842 10.7887 7.83629 10.7826 9.07103C10.7826 9.5608 10.531 11.0224 9.75186 12.419C9.37041 13.1001 8.93621 13.6358 8.45737 14.0031Z'
                  fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45245'>
                  <rect width='15.7895' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Understanding Your Business',
        text: `We start by gaining a deep understanding of your business, your industry, and your unique needs.`
      },
      {
        id: 2,
        icon: (
          <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clipPath="url(#clip0_618_42969)">
                <path d="M16.5951 1.03952L22.9421 7.38552C23.0075 7.45081 23.0536 7.53295 23.0751 7.62282C23.0966 7.71269 23.0928 7.80678 23.0642 7.89462C23.0355 7.98247 22.983 8.06064 22.9125 8.12047C22.8421 8.18029 22.7565 8.21943 22.6651 8.23352L21.1911 8.46352L15.5351 2.80752L15.7471 1.32252C15.7603 1.23069 15.7988 1.14434 15.8582 1.07312C15.9177 1.00191 15.9958 0.948637 16.0838 0.919269C16.1718 0.889901 16.2662 0.885595 16.3565 0.906832C16.4468 0.928069 16.5294 0.974011 16.5951 1.03952ZM4.59412 20.1495C8.31612 16.8185 12.5891 15.8215 17.2371 14.6295L17.6831 10.6115L13.3861 6.31452L9.36813 6.76052C8.17613 11.4085 7.17912 15.6805 3.84812 19.4035L2.45312 18.0095C5.28113 14.7095 6.34312 11.0565 7.75612 4.92852L14.1201 4.22152L19.7771 9.87852L19.0701 16.2425C12.9421 17.6565 9.28813 18.7175 5.98912 21.5455L4.59412 20.1495ZM9.87812 14.1195C9.6871 13.935 9.53474 13.7143 9.42992 13.4703C9.3251 13.2263 9.26993 12.9639 9.26762 12.6983C9.26532 12.4328 9.31592 12.1694 9.41648 11.9236C9.51704 11.6778 9.66555 11.4545 9.85333 11.2667C10.0411 11.0789 10.2644 10.9304 10.5102 10.8299C10.756 10.7293 11.0194 10.6787 11.2849 10.681C11.5505 10.6833 11.8129 10.7385 12.0569 10.8433C12.3009 10.9481 12.5216 11.1005 12.7061 11.2915C13.0654 11.6696 13.2628 12.173 13.2563 12.6946C13.2497 13.2161 13.0396 13.7144 12.6709 14.0833C12.3021 14.4522 11.8039 14.6624 11.2824 14.6692C10.7608 14.6759 10.2573 14.4787 9.87913 14.1195H9.87812Z" fill="#8358FF"/>
              </g>
              <defs>
                <clipPath id="clip0_618_42969">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Strategy Formulation',
        text: `Based on our understanding, we formulate a tailored blockchain strategy for your business.`
      },
      {
        id: 3,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21' fill='none'>
              <g clipPath='url(#clip0_384_45265)'>
                <path
                  d='M18.0565 20.5H1.94354C0.871819 20.5 0 19.6282 0 18.5565V2.44354C0 1.37182 0.871819 0.5 1.94354 0.5H18.0588C19.1305 0.5 20.0023 1.37182 20.0023 2.44354V18.5627C19.9979 19.631 19.1249 20.5002 18.0565 20.5002V20.5ZM1.94354 2.35099C1.89519 2.35099 1.85099 2.39519 1.85099 2.44354V18.5565C1.85099 18.6048 1.89519 18.649 1.94354 18.649H18.0565C18.1055 18.649 18.1506 18.6048 18.1513 18.5558V2.44354C18.1513 2.39519 18.1071 2.35099 18.0588 2.35099H1.94354Z'
                  fill='#8358FF' />
                <path d='M19.0771 3.89062H0.925781V5.74162H19.0771V3.89062Z' fill='#8358FF' />
                <path
                  d='M7.69995 15.7557L3.89453 12.3476L7.69995 8.93945L8.93502 10.3184L6.66917 12.3476L8.93502 14.3768L7.69995 15.7557Z'
                  fill='#8358FF' />
                <path
                  d='M12.3015 15.7557L11.0664 14.3768L13.3323 12.3476L11.0664 10.3184L12.3015 8.93945L16.1069 12.3476L12.3015 15.7557Z'
                  fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45265'>
                  <rect width='20.0023' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Design and Development',
        text: `Our team of experts design and develop a custom blockchain solution that aligns with your business objectives.`
      },
      {
        id: 4,
        icon: (
          <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M13.9521 8.89258L10.1681 13.5926L8.43606 12.0366L6.66406 14.0046L10.4761 17.4286L16.0121 10.5526L13.9521 8.89258Z" fill="#8358FF"/>
              <path d="M15.6094 2V5.6H7.60938V2H9.24538C9.43338 0.864 10.4214 0 11.6094 0C12.7974 0 13.7854 0.864 13.9734 2H15.6094Z" fill="#8358FF"/>
              <path d="M17 4C18.1046 4 19 4.89543 19 6V21C19 22.1046 18.1046 23 17 23H6C4.89543 23 4 22.1046 4 21V6C4 4.89543 4.89543 4 6 4H6.81077H16.1892H17Z" stroke="#8358FF" stroke-width="1.7" stroke-miterlimit="10"/>
            </svg>
          </>
        ),
        title: 'Implementation and Testing',
        text: `We deploy the blockchain solution and rigorously test it for any discrepancies or security issues.`
      },
      {
        id: 5,
        icon: (
          <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M23.4931 9.34082C23.4916 8.56216 23.4895 7.7835 23.4902 7.00485C23.4902 6.51995 23.4036 6.04324 23.2333 5.5866C22.6533 4.0397 21.1819 3 19.5716 3H15.9862C12.3645 3 8.61973 3 4.93613 3.00372C4.63486 3.00372 4.34379 3.0357 4.06944 3.09891C3.27989 3.27963 2.60387 3.67677 2.06028 4.27843C1.36605 5.04667 1.01094 5.94953 1.00512 6.96022C0.99784 8.16725 1.00002 9.39437 1.00148 10.5806C1.00148 11.0104 1.00293 11.4403 1.00293 11.8702C1.00293 11.952 1.00948 12.039 1.02258 12.1297C1.07134 12.4666 1.33622 12.7738 1.63967 12.8444C2.00788 12.9307 2.36227 12.7961 2.56457 12.4941C2.67882 12.3238 2.73631 12.1394 2.73558 11.9453C2.73412 11.7289 2.73485 11.5117 2.73558 11.2953V9.92165C2.73703 8.97864 2.73776 8.03636 2.73558 7.09335C2.73485 6.61812 2.79816 6.29535 2.94734 6.01274C3.38978 5.17608 4.04761 4.76927 4.95942 4.76927H4.96087C6.72408 4.77002 8.48729 4.76927 10.2505 4.76927H12.3463C13.1911 4.76927 14.036 4.76927 14.8808 4.76927C15.6282 4.76927 16.3762 4.76927 17.1236 4.77002C17.916 4.7715 18.7354 4.77225 19.5424 4.76778C20.0293 4.76555 20.4317 4.88008 20.7722 5.1203C21.4352 5.5866 21.7561 6.20388 21.7546 7.00782C21.751 8.45209 21.7517 9.92091 21.7517 11.3414C21.7517 12.3275 21.7517 13.3144 21.751 14.3006V14.3311C21.751 14.6628 21.751 14.9759 21.6382 15.2659C21.3864 15.9159 20.9549 16.3532 20.3204 16.6016C20.0919 16.6908 19.8284 16.7325 19.4944 16.7295C19.0745 16.7265 18.6547 16.7265 18.2348 16.7273C17.884 16.7273 17.534 16.7273 17.1833 16.7258H17.1782C16.9162 16.7258 16.6964 16.8165 16.5254 16.9958C16.278 17.2553 16.2052 17.6123 16.3362 17.9276C16.481 18.2787 16.7714 18.4802 17.1323 18.4802H17.9182C18.5208 18.4802 19.1233 18.4795 19.7251 18.478C19.8743 18.478 19.9885 18.4705 20.0969 18.4542C20.6223 18.3761 21.0728 18.2206 21.4723 17.9797C22.7887 17.1869 23.4647 16.0312 23.4822 14.5453C23.5018 12.8095 23.4982 11.0454 23.4938 9.33933L23.4931 9.34082Z" fill="#8358FF"/>
              <path d="M11.0055 14.237C9.529 14.217 8.02777 14.2222 6.57674 14.2274C6.03897 14.2289 5.50048 14.2311 4.96271 14.2318C4.39656 14.2318 3.87626 14.3389 3.41709 14.5479C2.10723 15.1436 1.31259 16.1759 1.05426 17.6157C0.966206 18.1088 0.985126 18.5736 1.11247 18.999C1.47559 20.2142 2.51765 20.9995 3.76856 20.9995H6.65097H7.96155H9.09748C9.47006 20.9995 9.84773 21.0003 10.2276 21.0003C10.8745 21.0003 11.5273 21.0003 12.1734 20.9973C12.5984 20.9958 12.963 20.9215 13.2876 20.7697C14.3398 20.2782 14.8979 19.4288 14.9452 18.2441C14.9685 17.6707 14.8405 17.0966 14.5647 16.5388C13.8319 15.0544 12.6013 14.2594 11.0055 14.2378V14.237ZM12.6166 19.1574C12.5395 19.1909 12.434 19.2102 12.3183 19.2102C11.1787 19.2139 10.0195 19.2139 8.89809 19.2139H7.97173H7.75779C7.42087 19.2139 7.08395 19.2139 6.74775 19.2132C5.73553 19.2117 4.6891 19.2102 3.65941 19.2176C3.65723 19.2176 3.65504 19.2176 3.65359 19.2176C3.21915 19.2176 2.88732 18.8956 2.78399 18.5758C2.74688 18.4605 2.74397 18.3133 2.74469 18.1727C2.74833 17.4104 3.06779 16.8162 3.72272 16.3573C4.04727 16.1298 4.41403 16.0145 4.81281 16.0145H4.81717C5.8374 16.0167 6.85763 16.0167 7.87786 16.016C8.94612 16.016 10.0151 16.016 11.0834 16.0182C11.9413 16.0204 12.5715 16.4302 13.0081 17.2706C13.1435 17.5309 13.2155 17.8321 13.2235 18.1645C13.2315 18.4925 13.1326 18.9313 12.6173 19.1574H12.6166Z" fill="#8358FF"/>
              <path d="M7.96979 13.4873C7.99017 13.4873 8.00982 13.4873 8.02946 13.4873C9.73882 13.4873 11.2168 12.0259 11.2728 10.2626C11.3026 9.32107 10.9745 8.43681 10.3486 7.77343C9.73446 7.12269 8.88742 6.74712 8.02364 6.74414C8.01855 6.74414 8.01346 6.74414 8.00909 6.74414C7.1002 6.74414 6.25753 7.09219 5.63535 7.72583C5.01317 8.35947 4.67115 9.22142 4.67188 10.1518C4.6726 11.048 5.02117 11.8906 5.65354 12.5257C6.27426 13.1489 7.11839 13.5007 7.96979 13.4866V13.4873ZM8.00181 8.50746C8.96164 8.52531 9.54817 9.34115 9.55981 10.1198C9.56636 10.5467 9.38225 10.9758 9.05333 11.2964C8.7477 11.5946 8.35984 11.753 7.98799 11.7292H7.97562H7.96324C7.55646 11.7441 7.15041 11.5752 6.85133 11.2673C6.54133 10.9476 6.37396 10.5065 6.3936 10.0573C6.4329 9.1582 7.1213 8.49333 8.00108 8.50821L8.00181 8.50746Z" fill="#8358FF"/>
              <path d="M13.5 9H16.25H19" stroke="#8358FF" stroke-width="2" stroke-linecap="round"/>
              <path d="M13.5 12H16.25H19" stroke="#8358FF" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </>
        ),
        title: 'Training',
        text: `We offer training to your team to ensure they can effectively manage the blockchain solution.`
      },
      {
        id: 6,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21' fill='none'>
              <g clipPath='url(#clip0_384_45290)'>
                <path
                  d='M17.1354 20.0403C16.7498 20.0403 16.3881 19.89 16.1157 19.6198L6.55465 10.2244C5.80728 10.4161 5.02287 10.4292 4.26461 10.2636C3.34511 10.0609 2.50405 9.60119 1.8373 8.93227C1.16838 8.26334 0.708629 7.42446 0.505991 6.50714C0.309889 5.61379 0.364362 4.68557 0.665051 3.82054L1.00714 2.8335L3.60004 5.43076L5.09695 5.20633L5.32138 3.70942L2.72412 1.11652L3.70899 0.774426C4.57184 0.473737 5.50223 0.419264 6.39559 0.615366C7.31509 0.818004 8.15397 1.27775 8.82289 1.94668C9.49182 2.61561 9.95157 3.45449 10.1542 4.37399C10.3198 5.13007 10.3067 5.9123 10.1172 6.65748L12.0499 8.55531L19.6804 16.0529C20.2447 16.6173 20.2447 17.5324 19.6804 18.0968L18.1617 19.6155C17.885 19.89 17.5211 20.0403 17.1354 20.0403ZM6.90545 8.73616L17.0374 18.6916C17.0701 18.7243 17.1093 18.733 17.1354 18.733C17.1616 18.733 17.1986 18.7265 17.2335 18.6916L18.7522 17.1729C18.8067 17.1184 18.8067 17.0335 18.7544 16.979L11.1304 9.49007L8.62025 7.02572L8.75535 6.63569C9.21074 5.32835 8.87083 3.85105 7.8925 2.87272C7.17781 2.15803 6.22999 1.78544 5.25819 1.80723L6.70499 3.25185L6.24088 6.35679L3.13594 6.8209L1.69132 5.37411C1.66953 6.34372 2.04212 7.29155 2.75681 8.00841C3.73514 8.98674 5.21244 9.32447 6.51978 8.87126L6.90545 8.73616Z'
                  fill='#8358FF' />
                <path
                  d='M3.14635 20.5004C2.79554 20.5004 2.44256 20.3675 2.17673 20.0995L0.403098 18.3259C0.143808 18.0666 0 17.7201 0 17.3519C0 16.9836 0.143808 16.6372 0.403098 16.3779L4.96792 11.8131C4.99188 11.7891 5.01585 11.7695 5.02893 11.7586C5.47342 11.3686 6.13145 11.3446 6.6021 11.702C6.60863 11.7063 6.61735 11.7129 6.62825 11.7216C6.63696 11.7281 6.64786 11.7368 6.66093 11.7477C6.67836 11.7608 6.70669 11.7826 6.73719 11.8131L8.69167 13.7676C8.72218 13.7981 8.74397 13.8264 8.75922 13.8438C8.77229 13.8613 8.78319 13.8765 8.79408 13.8896L8.79626 13.8918C9.16232 14.369 9.13835 15.0379 8.73525 15.4867L8.73307 15.4889C8.71782 15.5042 8.70475 15.5194 8.68949 15.5347L4.11596 20.0995C3.85013 20.3675 3.49715 20.5004 3.14635 20.5004ZM5.85255 12.7784L1.32696 17.3039C1.3117 17.3192 1.30735 17.3388 1.30735 17.3519C1.30735 17.365 1.3117 17.3846 1.32696 17.3998L3.10059 19.1735C3.12674 19.1996 3.16814 19.1996 3.1921 19.1735L7.71988 14.6457L5.85255 12.7784Z'
                  fill='#8358FF' />
                <path d='M15.7344 3.96684L11.125 8.55859L12.0477 9.4848L16.6571 4.89304L15.7344 3.96684Z'
                      fill='#8358FF' />
                <path d='M8.48154 11.1915L6.83203 12.833L7.7542 13.7597L9.40371 12.1182L8.48154 11.1915Z'
                      fill='#8358FF' />
                <path
                  d='M17.6599 5.36719L16.1477 5.30618L15.25 4.40847L15.2827 2.95295L17.8582 1.13574L19.4923 2.76992L17.6599 5.36719ZM16.712 4.02062L17.0018 4.03151L17.7884 2.91591L17.7122 2.83965L16.5748 3.64149L16.5704 3.87899L16.712 4.02062Z'
                  fill='#8358FF' />
                <path d='M6.00178 13.6222L2.14844 17.4756L3.07287 18.4L6.92622 14.5467L6.00178 13.6222Z' fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45290'>
                  <rect width='20.1033' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Maintenance and Support',
        text: `We provide ongoing support and maintenance to ensure smooth operations of your blockchain solution.`
      }
    ]
  };

  const drawerItems = [
    {
      title: 'Supply Chain Management',
      desc: 'Enhancing traceability and accountability in goods\' journey',
      img: '/images/card-drawer/consulting/item-01.svg',
      id: 1
    },
    {
      title: 'Finance and Payments',
      desc: 'Utilize blockchain for faster, secure, and cost-effective transactions.',
      img: '/images/card-drawer/consulting/item-02.svg',
      id: 2
    },
    {
      title: 'Digital Identity Verification',
      desc: 'nhance your customer verification process and protect their data with blockchain.',
      img: '/images/card-drawer/consulting/item-03.svg',
      id: 3
    },
    {
      title: 'Real Estate Transactions',
      desc: 'Make property transactions more transparent and efficient using blockchain.',
      img: '/images/card-drawer/consulting/item-04.svg',
      id: 4
    },
    {
      title: 'Intellectual Property Rights',
      desc: 'Secure your creative content from infringement through blockchain.',
      img: '/images/card-drawer/consulting/item-05.svg',
      id: 5
    },
    {
      title: 'Voting Systems',
      desc: 'Ensure transparency and security in voting systems using blockchain technology.',
      img: '/images/card-drawer/consulting/item-06.svg',
      id: 6
    }
  ];
  const servicesData = [
    {
      title: 'Blockchain strategy development',
      desc: "We help you understand and leverage the potential of blockchain in your business.",
      id: '1',
      icon: '/images/services/blockchain-consulting/services-01.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
    {
      title: 'Implementation guidance',
      desc: "Our team guides you in applying blockchain technology in the most effective way.",
      id: '2',
      icon: '/images/services/blockchain-consulting/services-02.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
    {
      title: 'Smart contract development and audit',
      desc: "We ensure your contracts are secure, reliable, and efficient.",
      id: '3',
      icon: '/images/services/blockchain-consulting/services-03.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
    {
      title: 'Tokenomics consulting',
      desc: "We help design the token economics of your blockchain solution for optimal functionality.",
      id: '4',
      icon: '/images/services/blockchain-consulting/services-04.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
    {
      title: 'Training and workshops',
      desc: "Empower your team with the knowledge of blockchain through our bespoke training programs.",
      id: '5',
      icon: '/images/services/blockchain-consulting/services-05.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
    {
      title: 'Support and maintenance',
      desc: "We offer ongoing support to ensure smooth functioning of your blockchain solution.",
      id: '6',
      icon: '/images/services/blockchain-consulting/services-06.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
  ];
  const itemList = [
    {
      containerClass: 'w-full',
      row: [
        {
          title: 'Illuminate the Path',
          desc: 'We demystify blockchain technology for you, translating complex concepts into understandable terms.'
        },
        {
          title: 'Identify Opportunities',
          desc: 'We analyze your business to identify how blockchain can enhance efficiency and value.'
        },
        {
          title: 'Mitigate Risks',
          desc: 'We provide you with the strategies to manage risks associated with blockchain implementation.'
        },
        {
          title: 'Mitigate Risks',
          desc: 'We provide you with the strategies to manage risks associated with blockchain implementation.'
        },
      ]
    },
  ];

  return (
    <div>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
      <Hero_10 content={content} />
      <Parks
        title={'Harnessing the Power of Blockchain'}
        subTitle1={'Blockchain revolutionizes digital trust and decentralization. Blockchain technology may improve operations, build stakeholder trust, and create new development prospects.'}
        subTitle2={'With blockchain\'s rapid popularity, businesses must learn how to incorporate this game-changing technology into their plans. Blockchain consultancy helps people understand its complexity. We\'ll assist:'}
        image={'/images/features/consulting-reason.png'}
        animationImage={'/images/features/consulting-reason-side.png'}
        list={itemList}
      />
      <Services
        title={`Our blockchain consulting services bridge the gap between traditional business practices and the digital future`}
        servicesData={servicesData}
      />
      <CardDrawer
        title={'Unleashing Blockchain’s Potential in Your Business'}
        subTitle={'Every firm has different requirements, and we have expertise working with a variety of industries. Among the most common uses for our blockchain consulting services are:'}
        drawerItems={drawerItems} />
      <Features title={'Our Blockchain Consulting Process'} subTitle={'Our proven process makes blockchain implementation seamless and efficient. At Alchemis, we know the ropes of blockchain consulting, and our approach involves:'}
                featuresContent={features_data} />
      <FeaturesCard
        title={'Why Alchemis?'}
        subTitle={'Our technical prowess spans a multitude of blockchain platforms, allowing us to deliver solutions tailored to your business needs:'}
      />
      <CallToActions
        title={"Join us in revolutionizing the digital space with decentralized app development."}
        background={"/images/cta.png"}
        description={"Contact us today to see how our Web3 solution will help you realise your full business potential!"}
        btnText={"Start Now"}
        link={"/contact"}
      />
    </div>
  );
}

export default BlockchainConsulting;
